import {FirebaseFunctionsError} from '../../shared/customerrors.js';
export class RenderCtrl {
  constructor(RenderService, $scope) {
    'ngInject';
    
    this.$scope = $scope;
    this.rs = RenderService;
    
    this.$location = RenderService.$location;
    this.$document = RenderService.$document[0];
    this.$interval = RenderService.$interval;
    this.$state = RenderService.$state;
    this.$timeout = RenderService.$timeout;
    this.$uibModal = RenderService.$uibModal;
    this.$window = RenderService.$window;
    this.$sce = RenderService.$sce;

    this.ac = RenderService.ActionService;
    this.as = RenderService.AuthService;
    this.ds = RenderService.DomService;
    this.es = RenderService.EventService;
    this.fe = RenderService.FEService;
    this.featureAccess = RenderService.featureAccess;
    this.fs = RenderService.FlashService;
    this.rcs = RenderService.RecordService;
    this.sls = RenderService.ScriptLoaderService;
    this.ss = RenderService.SchemaService;
    this.tb = RenderService.TBService;
    this.trs = RenderService.TokenRefreshService;
    this.ts = RenderService.TemplateService;
    this.qps = RenderService.QueryParamService;
    this.gl = RenderService.GeoLocationService;
    
    this.busyMessage = 'Loading Form...';
    this.redirectScreenHtml = '';
    this.builderUrl = null;
    this.controlsLoaded = 0;
    this.hasCriticalError = false;
    this.hideActions = false;
    this.loginRequired = true;
    this.missingRequiredFields = false;
    this.paramsValid = null;
    this.formLoaded = false;
    this.PROVIDER = null;
    this.schemas = {};
    this.loadedCalled = false;
    
    this.visiblePage = null;
    this.tabNumbers = {};
    this.controlModelsReady = false;
    this.fieldSections = [];
    this.td = null;
    this.userMessages = [];
    this.previousAction = this.$state.params.previousAction;
    this.successType = this.$state.params.successType;
    this.keepWorking = this.$state.params.keepWorking;
    this.downloadOnOpen = this.$state.params.download == "true";
    this.autoPdfDownloadDone = false;
    this.downloadCompleted = false;
    if (this.downloadOnOpen && !this.isBackendCall) this.busyMessage = 'Downloading document';
    this.suppliedConnection = this.as.suppliedConnection();
    this.passkeys = [];
    this.setActionButtonsDisabled(true);
    this.hasInvalidFields = true;
    this.defaultPrintCss = '';
    this.handleReload();
    
    this.rs.iosClassTag();
  }

  get rids() {
    return this.qps.getParsedParam('rids');
  }

  // Signed templates derive action from link targets; unsigned uses URL action param.
  get action() {
    if (this.td?.template?.signTemplate === true) {
      return this.signedEffectiveAction();
    }
    return this.ac.action;
  }

  // Signed links read enableSaveAndKeepWorking from link config, not template flag alone.
  enableSaveAndKeepWorkingEnabled() {
    if (this.td?.template?.signTemplate !== true) {
      return !!this.td?.template?.enableSaveAndKeepWorking;
    }
    const signedRaw = this.qps.getRawParam('providerSignedAccess');
    const serverSignedRaw = this.qps.getRawParam('serverSignedAccess');
    const submitLinkRaw = this.qps.getRawParam('submitLinkId');
    if (!signedRaw?.length && !serverSignedRaw?.length && !submitLinkRaw?.length) return false;
    if (this.rcs.isDownloadOnlySignedLink?.()) return false;
    const flag = this.rcs.associatedLink?.enableSaveAndKeepWorking;
    return flag !== false;
  }

  // Derive effective action from signed link targets when URL has no action param.
  signedEffectiveAction() {
    const serverSignedRaw = this.qps.getRawParam('serverSignedAccess');
    if (serverSignedRaw?.length && !this.rcs.isEditableSignedWorkingSession()) return 'print';
    const signedRaw = this.qps.getRawParam('providerSignedAccess');
    const submitLinkRaw = this.qps.getRawParam('submitLinkId');
    const editableSession = this.rcs.isEditableSignedWorkingSession();
    if (!editableSession && this.keepWorking) return 'update';
    if (signedRaw?.length || submitLinkRaw?.length || editableSession) {
      const targets = this.rcs.signedLinkTargets ?? this.rcs.associatedLink?.targets ?? [];
      if (!targets.length) return 'print';
      const hasSubmit = targets.some((t) => t.action === 'submit');
      const hasUpdate = targets.some((t) => t.action === 'update');
      const hasPrint = targets.some((t) => t.action === 'print');
      // This needs to be refactored!! :O
      if (hasSubmit && !hasUpdate && !hasPrint) return 'submit';
      if (hasPrint && !hasSubmit && !hasUpdate) return 'print';
      return 'update';
    }
    return 'print';
  }

  // True when render URL carries PSA, submit link, or server-signed access token.
  hasSignedLinkSession() {
    return !!(
      this.qps.getRawParam('providerSignedAccess')?.length ||
      this.qps.getRawParam('submitLinkId')?.length ||
      this.qps.getRawParam('serverSignedAccess')?.length
    );
  }

  // downloadOnOpen from link config or URL param after associated link loads.
  resolveDownloadOnOpen() {
    const urlDownload = this.$state.params.download == "true";
    if (this.td?.template?.signTemplate === true && this.hasSignedLinkSession()) {
      const linkDownload = this.rcs.associatedLink?.downloadOnOpen === true;
      return linkDownload || urlDownload;
    }
    return urlDownload;
  }

  // Sync downloadOnOpen flag once link metadata is available from preload.
  applyDownloadOnOpenFromLink() {
    const next = this.resolveDownloadOnOpen();
    if (next === this.downloadOnOpen) return;
    this.downloadOnOpen = next;
    if (this.downloadOnOpen && !this.isBackendCall) this.busyMessage = 'Downloading document';
  }

  get redirect() {
    return this.ac.redirect;
  }

  get reload() {
    return this.ac.reload;
  }

  get retrying() {
    return this.ac.retrying;
  }

  // Show inline retry error in passkey modal after failed signed-link passkey attempt.
  get showPasskeyRetryError() {
    const retrying = this.retrying;
    return retrying === true || retrying === 'true';
  }

  get actionLabel() {
    switch (this.action) {
      case 'print':
        return 'download';
      case 'update':
        return 'submit';
      default:
        return this.action;
    }
  }

  get printing() {
    return (this.action === 'print');
  }

  // Hide navbar during auto-download-on-open (form hidden until PDF completes).
  get showRenderNavBar() {
    return this.formLoaded && !this.hideFormForDownloadOnOpen;
  }

  get updating() {
    return (this.action === 'update');
  }

  get submitting() {
    return (this.action === 'submit');
  }

  get isDynamic() {
    return this.td?.template?.type === 'dynamic';
  }

  get isBackendCall() {
    return this.ac.isBackendCall;
  }

  // Hide form chrome while auto-downloading PDF on open (not headless backend render).
  get hideFormForDownloadOnOpen() {
    return this.downloadOnOpen && !this.isBackendCall;
  }

  /** Passkey modal: initial signed open only; serverSignedAccess URLs skip re-prompt. */
  get applyPasskeys() {
    if (this.qps.getRawParam('serverSignedAccess')?.length > 0) return false;
    return !this.isBackendCall && (this.updating || (this.printing && !this.previousAction));
  }
  
  async $onInit() {
    if (this.reload) return;
    this.setDefaultCss();
    this.setGlobalFuncs();
    this.handleSuccessMessage(this.successType);
    this.bindBasicComponentEvents();
    await this.loadTemplate();
    if (!this.td) return;

    if (this.td.template.signTemplate === true && !this.hasSignedLinkSession()) {
      this.handleError(
        new Error('This signed form must be opened from a secure link.'),
        'danger'
      );
      return;
    }

    const isSignedLinkSession =
      this.td.template.signTemplate === true && this.hasSignedLinkSession();

    // Signed open: preload before passkeys/geo so targets and associatedLink are available.
    if (isSignedLinkSession) {
      this.applyBackendPasskeysFromUrl();
      this.rcs.preLoadRecords();
      try {
        await this.rcs.recordsPromise;
      } catch (error) {
        const err = error instanceof FirebaseFunctionsError ? error : error;
        if (this.isSignedLinkRecordNotFoundError(err)) {
          this.handleError(new Error(err.message || 'This link cannot be opened.'), 'danger');
          this.setFormError('danger');
          return;
        }
        throw error;
      }
      this.applyDownloadOnOpenFromLink();
      await this.loadSignedLinkPasskeys();
    } else {
      await this.handlePasskeys();
      this.rcs.preLoadRecords();
    }
    if (!this.td) return;

    // Signed links: wait until targets resolve so `printing` is not falsely true pre-load.
    await this.initGeoData();

    await this.loadProviderSettings();
    await Promise.all([
      this.loadLibraries(),
      this.loadProviderData()
    ]);
    this.validateLoadedRecords();
    console.info(this.rcs.records);
    this.adjustAction();
    this.validateParams();
    this.loadSchemas();
    this.setConfirmLeave();
    this.handleFieldProblems();
    this.handleCustomMessage();
    await this.handleRedirect();
    this.controlModelsReady = true;
    this.bindMainComponentEvents();
  }
  
  $onDestroy() {
    this.es.disposeSubscribers("template");
    this.$window.onbeforeunload = undefined;
  }

  setDefaultCss() {
    if (this.isBackendCall) return;
    this.defaultPrintCss = `
      @media print {
        @page { margin: 0; /* removes default page margins */ }
        body { margin: 0; /* removes body padding/margins */ }
      }`;
  }

  handleReload() {
    if (this.reload) {
      const url = this.$location.absUrl().replace("&reload=true", "");
      this.reloadUrl(url);
    }
  }

  retryForm() {
    this.reloadUrl(this.$location.absUrl().replace("&retrying=true", "") + "&retrying=true");
  }

  reloadUrl(url) {
    this.$window.history.replaceState({}, null, url);
    this.$window.location.reload();
  }

  setGlobalFuncs() {
    this.$window["setVisiblePage"] = (pageNumber) => {
      this.visiblePage = pageNumber;
      this.$scope.$apply();
    };
  }

  async loadTemplate() {
    try {
      this.td = await this.ts.getTemplateData();
      this.ts.removeTempObjects(this.td);
      if (!this.td) throw new Error('Could not load template data');
      this.$scope.$apply();

      this.$state.current.data.title = this.td.template.title + ': ' + this.action + ' - Form Engine';

      this.builderUrl = this.fe.builderUrl(this.td.template);
    } catch(error) {
      this.handleError(error, error.level || 'danger');
    }
  }

  loadSchemas() {
    this.schemas = this.ss.getTemplateSchemas(this.td.template);
  }

  loadFieldSections() {
    const tokenPos = this.td.template.tokens
      .map(t => { 
        return { 
          top: $(`.token-id-${t.id}`).offset()?.top,
          sectionName: t.options?.sectionName?.trim()
        };
      });
    tokenPos.sort((a, b) => a.top - b.top);
    this.fieldSections = Array.from(new Set(tokenPos.map(t => t.sectionName).filter(s => s)));
  }

  handleNavBar() {
    this.$timeout(_ => $('#render-header-section:visible').length ? $('body').addClass('has-nav-bar') : $('body').removeClass('has-nav-bar'), 100);
  }

  handleAfterLoadMessages() {
    this.gl.unavailable && this.fs.error("Couldn't access geolocation data, make sure you turn on geolocation for this site!");
  }

  async loadProviderSettings() {
    this.PROVIDER = await this.ts.PROVIDER;
  }

  async loadProviderData() {
    do {
      try {
        await this.rcs.recordsPromise;
        this.rcs.validatePrefills();
        
        this.notifySuccessPrint();
        
        this.$scope.$apply(() => { //this is necessary, but WHY?
          this.loginRequired = false;
        });

      } catch (error) {
        const renderErrorAction = this.fe.getRenderErrorAction(
          error, this.successType, this.previousAction
        );
        
        if (renderErrorAction) {
          await this[renderErrorAction]();
          return this.busyMessage = '';
        } else {
          throw error;
        }
      }
    } while (this.loginRequired);
  }

  async initGeoData(update = false) {
    if (this.printing) return;
    if (this.td.template.tokens.some(t => !!t.options?.geoData)) await this.gl.getPosition(update);  
  }

  async adjustAction() {
    const template = await this.ts.getTemplate();
    if (!this.printing && template.references.length < 1) {
      // Need to change action. Nothing to update or submit
      this.qps.setRawParam('action', 'print');
    }
  }

  bindBasicComponentEvents() {
    this.es.subscribeEvent(
      this.es.actions.AUTHENTICATE, 
      data => {
        if (data?.error?.details?.validationErrorMessage) this.fs.error(data?.error?.details?.validationErrorMessage);
        if (data?.updateConnection) this.$timeout(_ => this.handleError(new Error("The form's connection info isn't valid, please contact the form owner!"), "danger"));
        else this.promptLogin(data?.error?.details);
      },
      'AUTHENTICATE');
    this.es.subscribeEvent(
      this.es.actions.MODEL_UPDATED, 
      _ => this.$timeout(_ => this.updateFormValidity(), 100),
      'MODEL_UPDATED');
  }

  bindMainComponentEvents() {
    const content = this.td?.template?.content || '';
    const exp = this.ts.tokens
      .filter(t => !t._temp && this.rcs.recordReferences.some( r => r.id === t.referenceId )
        && (!this.isDynamic || content.includes(t.id))).length;
    exp === 0 && this.loaded();

    $(window).unbind('keydown');
    $(window).bind('keydown', event => { this.keyDown(event) });

    this.es.subscribeEvent(
      this.es.actions.CONTROL_LOADED, 
      (token) => { 
        if (token._temp) return;
        
        this.controlsLoaded += 1;
        if(this.controlsLoaded == exp) {
          console.info(`all controls loaded (${this.controlsLoaded})`);
          this.es.dispatchEvent(this.es.actions.RECORDS_UPDATED, this.rcs.records);
          this.loaded();
        }
      },
      'CONTROL_LOADED_ALL');

    this.es.subscribeEvent(
      this.es.actions.FIELD_UPDATED, 
      ({token, model}) => this.rcs.fieldUpdated(token, model),
      'FIELD_UPDATED_ANY'
    );
  }

  renderCustomActionButtons() {
    const actionSelectors = Object.keys(this.fe.buttonActions).map(key => `button.fe-action-${key}`).join(',');
    $(actionSelectors).hide();

    this.$customActionButtons = $(`button.fe-action-${this.action}`);
    this.$customActionButtons.show();
    
    // TODO: this needs to be updated!!!
    if (this.submitting || this.updating) {
      const $continueButtons = $(`button.fe-action-continue`);
      $continueButtons.show();
      this.$customActionButtons = this.$customActionButtons.add($continueButtons);
    }
    
    this.$customActionButtons.click((event) => {
      const $button = $(event.target);
      const isContinueButton = $button.hasClass(`fe-action-continue`);
      this.attemptAction(isContinueButton);
    });
  }

  disableCustomActionButtons(disabled) {
    if (!this.$customActionButtons || this._disabledCustomActionButtons === disabled) return;
    this.$customActionButtons?.prop("disabled", disabled);
    this._disabledCustomActionButtons = disabled;
  }

  setActionButtonsDisabled(disabled) {
    this.actionBtnDisabled = disabled;
    this.disableCustomActionButtons(disabled);
  }

  keyDown(event) {
    const ctrlPressed = this.ds.isCtrlPressed(event);
    const activeElement = this.$document.activeElement.tagName.toUpperCase();
    if (ctrlPressed && activeElement == 'BODY' && event.code == 'KeyI') this.showRecInfo();
    if (ctrlPressed && activeElement == 'BODY' && event.code == 'Digit0') this.showDebugInfo();
  }

  // Signed PSA passkeys use inline modal retry instead of full page reload.
  usesSignedLinkPasskeyFlow() {
    return this.td?.template?.signTemplate === true
      && this.hasSignedLinkSession()
      && this.rcs.associatedLink?.passkey?.entries?.length > 0
      && this.applyPasskeys;
  }

  // Puppeteer PDF render passes passkeys on URL — apply before preload without modal.
  applyBackendPasskeysFromUrl() {
    if (!this.isBackendCall) return;
    const raw = this.qps.getRawParam('passkeys');
    if (!raw?.length) return;
    try {
      const parsed = this.qps.decodeParam(raw);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed) && Object.keys(parsed).length) {
        this.rcs.passkeys = parsed;
      }
    } catch (_e) {
      /* ignore malformed passkeys param */
    }
  }

  // Prompt for link passkeys, reload records, and retry inline until valid or dismissed.
  async loadSignedLinkPasskeys() {
    if (!this.applyPasskeys) return;
    if (!this.rcs.associatedLink?.passkey?.entries?.length) return;

    for (;;) {
      await this.handlePasskeys();
      if (!this.rcs.passkeys || !Object.keys(this.rcs.passkeys).length) return;

      await this.rcs.reloadRecordsWithPasskeys();
      this.applyDownloadOnOpenFromLink();

      const invalid = this.rcs.invalidPasskeys && Object.keys(this.rcs.invalidPasskeys).length > 0;
      if (!invalid) {
        if (this.retrying) this.$location.search('retrying', null);
        return;
      }

      this.rcs.clearPasskeys();
      this.rcs.clearInvalidPasskeys();
      if (!this.retrying) {
        this.$location.search('retrying', 'true');
      }
    }
  }

  async handlePasskeys() {
    if (!this.applyPasskeys) return;

    const isSigned = this.td?.template?.signTemplate === true;
    const linkPasskey = isSigned ? this.rcs.associatedLink?.passkey : null;

    if (isSigned) {
      if (!linkPasskey?.entries?.length) return;
      this.passkeys = linkPasskey.entries
        .map((entry) => {
          const ref = this.td.template.references.find((r) => r.id === entry.referenceId);
          if (!ref) return null;
          const field = ref.tableSchema?.fields?.find((f) => f.id == entry.passkeyFieldId);
          const label = field?.label || '?';
          const placeholder = String(entry.passkeyPlaceholder || '').trim() || ref.name;
          return {
            refId: ref.id,
            refName: ref.name,
            placeholder,
            fid: entry.passkeyFieldId,
            label,
            model: null,
            visible: false,
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.refName.localeCompare(b.refName));
    } else {
      this.passkeys =
        this.td.template.references
          .sort((r1, r2) => r1.name.localeCompare(r2.name))
          .filter(r => r.passkeyFID)
          .reduce((acc, ref) => { 
            const fid = ref.passkeyFID;
            const field = ref.tableSchema.fields.find(f => f.id == fid);
            const label = field?.label || '?';
            const placeholder = String(ref.passkeyPlaceholder || '').trim() || ref.name;
            acc.push({ refId: ref.id, refName: ref.name, placeholder, fid, label, model: null, visible: false }); 
            return acc; 
          }, []);
    }
    if (!this.passkeys.length) return;

    await this.showPasskeyModal(isSigned ? linkPasskey : null);
    this.rcs.passkeys = this.passkeys.reduce((acc, passkey) => { 
      acc[passkey.refId] = passkey.model; 
      return acc; 
    }, {});
  }

  // Passkey modal — link config overrides template message on signed links.
  showPasskeyModal(linkPasskeyConfig) {
    return new Promise((resolve, reject) => {
      const defaultMessage = 'Please refer to your confirmation email for Passkey.';
      const passkeyMessage = linkPasskeyConfig?.passkeyMessage
        || this.td?.template?.passkeyMessage
        || defaultMessage;
      const hasCustomMessage = !!(linkPasskeyConfig?.passkeyMessage || this.td?.template?.passkeyMessage);
      this.passkeyMessage = this.$sce.trustAsHtml(passkeyMessage);
      this.hasCustomPasskeyMessage = hasCustomMessage;
      
      this.modal = this.ds.openModal(this.$uibModal, {
        scope: this.$scope,
        backdrop: 'static',
        template: `
          <style>
            .modal-backdrop.in { opacity: 1; background-color: white; }
            .passkey-entry { padding: 5px; }
            .passkey-entry .input-group-addon.passkey-eye { padding: 0; background-color: #eee; color: #555; }
            .passkey-entry .passkey-eye-btn { padding: 6px 10px; border: 0; background: transparent; color: inherit; }
            .passkey-entry .passkey-eye-btn:hover { color: #333; }
          </style>
          <div>
            <div class="modal-header">
              <h4 class="modal-title" ng-if="!$ctrl.hasCustomPasskeyMessage">You are accessing a page that requires a Passkey.</h4>
              <h5 ng-if="!$ctrl.hasCustomPasskeyMessage">Please refer to your confirmation email for Passkey.</h5>
              <div ng-if="$ctrl.hasCustomPasskeyMessage" ng-bind-html="$ctrl.passkeyMessage"></div>
            </div>
            <div class="modal-body">
              <form name="passkeyForm" autocomplete="off">
                <div ng-repeat="passkey in $ctrl.passkeys">
                  <div class="input-group passkey-entry">
                    <span class="input-group-addon" id="basic-addon1">{{passkey.label}}</span>
                    <input type="{{ passkey.visible ? 'text' : 'password' }}" class="form-control" ng-model="passkey.model" required name="fe-access-code-{{$index}}" placeholder="{{passkey.placeholder}}" autocomplete="one-time-code"/>
                    <span class="input-group-addon passkey-eye">
                      <button type="button" class="passkey-eye-btn" ng-click="passkey.visible = !passkey.visible" tabindex="-1" title="{{ passkey.visible ? 'Hide passkey' : 'Show passkey' }}" aria-label="{{ passkey.visible ? 'Hide passkey' : 'Show passkey' }}">
                        <i class="fa" ng-class="passkey.visible ? 'fa-eye-slash' : 'fa-eye'"></i>
                      </button>
                    </span>
                  </div>
                </div>
                <div ng-if="$ctrl.showPasskeyRetryError" class="alert alert-danger">Invalid passkeys, try again!</div>
              </form>
            </div>
            <div class="btn-group btn-group-justified" role="group">
              <div class="btn-group" role="group">
                <button class="btn btn-primary" ng-click="$ctrl.modal.close()" ng-disabled="passkeyForm.$invalid">Continue</button>
              </div>
            </div>
          </div>`,
        keyboard: false,
        size: 'md'
      });

      this.modal.result.then(
        closed => { resolve() },
        canceled => { resolve() }
      );
    });
  }

  validateLoadedRecords() {
    if (this.submitting) return;
    const userMessage = { "class": `alert-warning`, "message": "Not all records were loaded!", key: "records-not-all-loaded" };
    const isSignedLink =
      this.td?.template?.signTemplate === true && this.hasSignedLinkSession();

    if (isSignedLink && (
      this.rcs.signedLinkRecordNotFoundWarn
      || this.rcs.signedLinkUpdatePrintTargetsMissingRecords()
    )) {
      this.userMessages.push(userMessage);
      return;
    }

    if (this.rcs.invalidPasskeys && Object.keys(this.rcs.invalidPasskeys).length > 0) {
      // Signed PSA passkeys re-prompt inline in loadSignedLinkPasskeys; unsigned uses full reload.
      if (!this.usesSignedLinkPasskeyFlow()) {
        this.retryForm();
      }
      return;
    }

    // Warn only if any provided records were not found (not if some references rids are missing in the url)
    if (!isSignedLink && this.rcs.recordCount < Object.keys(this.rcs.rids).length) {
      this.userMessages.push(userMessage);
    }
  }

  isSignedLinkRecordNotFoundError(error) {
    const msg = String(error?.message || '');
    return /signed link target .+ record not found/i.test(msg)
      || /signed link target .+ has no record id in the parent key field/i.test(msg);
  }

  searchSection() {
    this.modal = this.ds.openModal(this.$uibModal, {
      scope: this.$scope,
      template: `
        <div class="search-modal">
          <div class="modal-body">
            <div class="input-group">
              <div class="input-group-btn">
                <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100%">
                  Select a section <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" style="width:100%">
                  <li ng-repeat="section in $ctrl.fieldSections">
                    <a ng-click="$ctrl.selectSection(section)">{{ section }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>`,
      keyboard: false,
      size: 'md'
    });
    let renderedSearchPromise = this.modal.rendered.then(_ => {
      $(".search-modal .input-group-btn").toggleClass('open');
      renderedSearchPromise = null;
    });
  }

  selectSection(sectionName){
    this.modal.close();
    this.$timeout(_ => this.scrollToSection(sectionName), 200);
  }

  scrollToSection(sectionName) {
    const tokens = this.td.template.tokens.filter(t => t.options?.sectionName == sectionName);
    if (!tokens.length) return;

    const token = tokens[0];
    const element = this.$document.querySelector(`.token-id-${ token.id }`);
    element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
  }

  handleSuccessMessage(successType) {
    if (!this.printing || !successType) return;
    if (successType === 'submit') {
      this.successMessage('Form successfully submitted!', 10, 'submit-success');
    } else if (successType === 'update') {
      this.successMessage('Update successful!', 10, 'update-success');
    }
  }

  successMessage(message, displaySeconds, key) { //prevent duplicates
    this.$window.scrollTo({ top: 0 });
    if (!this.isDuplicateMsg(message)) {
      const entry = { "class": "alert-success", "message": message };
      if (displaySeconds != null) entry.closeInSeconds = displaySeconds;
      if (key != null) entry.key = key;
      this.userMessages.push(entry);
    }
  }
  
  isDuplicateMsg(message) {
    return this.userMessages.map(um => um.message).includes(message);
  }

  handleFieldProblems() {
    const missingRequired = this.tb.missingRequired;
    const refs = Object.keys(missingRequired);
    
    if(refs.length) { // Some required fields are not included in the form?
      this.handleMissingRequiredFields(refs, missingRequired);
    } else { // Some fields were removed from the table?
      this.handleMissingFields();
    }
  }

  getMissingFieldsString(tokens) { 
    return tokens.reduce(
      (acc, token) => {
        const ref = this.ts.references.find(r => r.id === token.referenceId);
        acc += `&nbsp;&bull;&nbsp;Table '${ref.name}' field '${token.fieldId}'.<br/>`;
        return acc;
      }, '<br/>');
  }

  handleMissingRequiredFields(refs, missingRequired) {
    const tokens = refs
      .reduce((acc, refReq) => {
        missingRequired[refReq].forEach(fid => acc.push({fieldId: fid, referenceId: refReq}));
        return acc;
      }, []);
    const fields = this.getMissingFieldsString(tokens);
    this.missingRequiredFields = true;
    const errorMessage = 
      `The form creator has not included required fields:
      ${fields}
      You cannot complete the form, please contact the form creator!`;
    throw Error(errorMessage);
  }

  handleMissingFields() {
    const tokensMissingField = this.td.template.tokens.filter(t => t.fieldSchema == null);
    if (tokensMissingField.length > 0) {
      const fields = this.getMissingFieldsString(tokensMissingField);
      const errorMessage = 
        `Some fields are missing, or your user lacks permissions to these fields:
        ${fields}
        You may still complete the form but please contact the form creator!`;
      this.fs.error(errorMessage);
    }
  }

  async loadLibraries() {
    if (!this.ac.isPrinting) {  
      if (this.td.template.tokens.some(t => this.PROVIDER.ckeditorControls.includes(t.control?.type))) {
        this.sls.importExternalPageScripts('renderer');
        await this.sls.waitForLibObject("CKEDITOR");
      }
    }
  }

  handleBackendError(error) {
    this.handleError(new Error(error.message));
    this.setFormError("warning"); // Do not block the form. TODO: should some errors block it?
  }

  handleError(error, level = "warning", key = "render-error") { 
    console.error(error);
    if (error instanceof FirebaseFunctionsError) {
      this.handleBackendError(error);
      return;
    }
    const message = error.message;
    this.$window.scrollTo({ top: 0 }); // always scroll, even if duplicate
    if (!this.isDuplicateMsg(message)) {
      const userMessage = { "class": `alert-${level}`, message, key };
      this.userMessages.push(userMessage);
      if (this.fe.handleRenderErrorMessage) {
        this.fe.handleRenderErrorMessage(
          userMessage, 
          (fid, label) => this.resetNoAccess(fid, label), 
          () => this.setFormError(level)
        );
      }      
    }
    
    this.busyMessage = '';
    this.loaded(); // Trigger the loaded indicator for "Callable Gen"
  }

  resetNoAccess(fid, label) { //reset field to prevent problem on second submission attempt 

    for (let key in this.schemas) {

      const { fields } = this.schemas[key];
      const matchedField = (fields.find(f => `${f.id}` === `${fid}`) || {}).label === label;

      if (matchedField) {
        const refIds = this.ts.references.filter(r => r.tableId === key).map(r => r.id);
        refIds.forEach(refId => {
          const token = this.ts.tokens.filter(t => t.referenceId === refId && t.fieldId === fid)[0];
          this.rcs.restrictField(refId, token.fieldId);
        });
      }

    }
  }

  setConfirmLeave() {
    this.$window.onbeforeunload = () => {
      if (this.rcs.hasUpdates && !this.ignoreLeaveConfirm) return 'Unsaved Changes will be lost.\nAre you sure you want to leave this page?';
    };
  }

  setFormError(level) {
    if (level === 'danger') this.hasCriticalError = true;
  }

  async promptLogin(options) {
    const { realm, provider, validationErrorMessage } = options;
    this.PROVIDER = await this.as.getProviderSettings({provider});
    const userRealm = await this.as.realm();
    this.fs.error(`You must login to ${realm}.${provider.toLowerCase()}.com before proceeding.`);
    this.ignoreLeaveConfirm = true;
    await this.openLoginModal(realm, userRealm, validationErrorMessage);

    this.fs.success("Reloading now...");
    this.$timeout(() => {
      this.$window.location.reload();
    });
  }

  validateParams() {
    this.paramsValid = this.validParams();
    if (!this.paramsValid) {
      throw Error("Something went wrong. Please check the URL and try again. Invalid parameters.");
    }
  }

  // True when URL still has rids param — forbidden on signed-link sessions.
  hasUrlRids() {
    const urlRids = this.qps.getParsedParam('rids');
    return Object.keys(urlRids || {}).some((refId) => {
      const v = urlRids[refId];
      if (v === null || v === undefined) return false;
      return typeof v !== 'string' ? true : v.trim().length > 0;
    });
  }

  validParams() {
    const { rids, action } = this;
    const signedRaw = this.qps.getRawParam("providerSignedAccess");
    const signed = signedRaw?.length > 0;
    const submitLinkRaw = this.qps.getRawParam("submitLinkId");
    const submitLink = submitLinkRaw?.length > 0;
    const serverSignedRaw = this.qps.getRawParam("serverSignedAccess");
    const serverSigned = serverSignedRaw?.length > 0;
    const validTId = typeof this.ts.templateId === "string";
    const templateExists = !!this.td.template.id;
    const urlRidsForbidden = this.hasUrlRids() && (this.td.template.signTemplate === true || signed || submitLink || serverSigned);
    if (urlRidsForbidden) return false;
    if (this.td.template.signTemplate === true) {
      const validSignedAccess = signed || submitLink || serverSigned || !this.ac.action;
      return validTId && templateExists && validSignedAccess;
    }
    if (submitLink) return false;
    const validRids = action === "submit" || this.validRids(this.ts.references, rids);
    const validAction = ["update", "print", "submit"].indexOf(action) >= 0;
    return validTId && validRids && validAction && templateExists;
  }

  validRids(refs, rids) {
    const ridKeys = Object.keys(rids || {}).sort();
    const refIds = refs.map(({id}) => id).sort();

    return Array.isArray(refIds) &&
      ridKeys.every(refId => refIds.includes(refId) && this.numOrString(rids[refId]));
  }

  numOrString(value) {
    return typeof value === "string" || typeof value === "number";
  }

  handleCustomMessage(displaySeconds) { // NOTE displaySeconds not used in custom message yet 06/22
    let fieldSuccessMsg = null;
    if (this.td?.template?.signTemplate === true) {
      const cfg = this.rcs.associatedLink?.successMessage;
      if (cfg?.referenceId && cfg?.fieldId) {
        fieldSuccessMsg = this.rcs.records[cfg.referenceId]?.[cfg.fieldId]?.value ?? null;
      }
    } else {
      const ref = this.ts.references.find(r => r.successMessageFID);
      fieldSuccessMsg = ref?.successMessageFID ? this.rcs.records[ref.id][ref.successMessageFID]?.value : null;
    }
    const message = this.td?.template?.signTemplate === true
      ? fieldSuccessMsg
      : (fieldSuccessMsg || this.td.template.successMessage);
    if (!message || !this.successType || !this.printing) return;
    this.userMessages.push({
      "message": message, 
      "type": "modal",
      "closeInSeconds": displaySeconds
    });
  }

  // Redirect field from associated link config on signed templates.
  getRedirectRef() {
    if (this.td?.template?.signTemplate === true) {
      const cfg = this.rcs.associatedLink?.redirect;
      if (!cfg?.referenceId || !cfg?.fieldId) return undefined;
      return {
        id: cfg.referenceId,
        redirectFID: cfg.fieldId,
        redirectOnLoad: !!cfg.onLoad,
      };
    }
    return this.ts.references.find(r => r.redirectFID);
  }

  // Custom plain-text redirect message from the signed link config (shown on the loader).
  // Custom HTML screen configured on the signed link's redirect, shown instead of the loader.
  getRedirectScreenHtml() {
    if (this.td?.template?.signTemplate !== true) return '';
    const cfg = this.rcs.associatedLink?.redirect;
    if (!cfg?.referenceId || !cfg?.fieldId || cfg.customScreen !== true) return '';
    return typeof cfg.message === 'string' ? cfg.message.trim() : '';
  }

  getTemplateIdFromUrl(url) {
    try {
      const parsed = url instanceof URL ? url : new URL(String(url), this.$window.location.href);
      const fromSearch = parsed.searchParams.get('templateId');
      if (fromSearch) return fromSearch;
      const hash = parsed.hash || '';
      const qIndex = hash.indexOf('?');
      if (qIndex < 0) return null;
      return new URLSearchParams(hash.slice(qIndex + 1)).get('templateId');
    } catch {
      return null;
    }
  }

  isSameTemplateRedirect(redirURL) {
    const currentId = this.ts?.templateId;
    if (!currentId || !redirURL) return false;
    const targetId = this.getTemplateIdFromUrl(redirURL);
    return !!targetId && targetId === currentId;
  }

  // Redirect URL known right now: ?redirect= param, else the value already loaded on the record.
  getLoadedRedirectValue(ref = this.getRedirectRef()) {
    if (this.redirect) return this.redirect;
    if (!ref) return null;
    const redirectField = this.rcs.records?.[ref.id]?.[ref.redirectFID];
    return redirectField?.value || redirectField?.display || null;
  }

  hasKnownRedirectUrl() {
    const url = this.getLoadedRedirectValue();
    return !!url && this.fe.isValidUrl(url);
  }

  async handleRedirect() {
    if (this.submitting || this.keepWorking) return;

    const ref = this.getRedirectRef();
    const hasRedirInfo = !!ref || !!this.redirect;
    const canRedirect = !!this.previousAction ^ !!ref?.redirectOnLoad;
    if (!hasRedirInfo || !canRedirect) return;
    
    // there is a race condition related to page reloads on WebKit browsers requiring
    // (await this.rcs.recordsPromise) to be evaluated (again) in event of a page reload
    try {
      let redirectValue = null;
      if (this.redirect) {
        redirectValue = this.redirect;
      } else if (ref && (await this.rcs.recordsPromise)) {
        redirectValue = this.getLoadedRedirectValue(ref);
      }

      this.redirURL = redirectValue;

      if (!this.redirURL) return;
      if (!this.fe.isValidUrl(this.redirURL)) throw(`"${this.redirURL}" is not a URL.`);

      // Skip on-load redirect to the same template — would infinite-loop via reloadUrl.
      if (ref?.redirectOnLoad && !this.previousAction && this.isSameTemplateRedirect(this.redirURL)) {
        console.warn('Skipped redirect on load: target templateId matches the current template.');
        this.redirURL = null;
        return;
      }

      this.hideActions = true;
      this.ignoreLeaveConfirm = true;
      this.busyMessage = 'Redirecting...';
      this.redirectScreenHtml = this.getRedirectScreenHtml();
      // We're past an await, so refresh the view before the page navigates away.
      this.$scope.$evalAsync();
      if (this.$window.location.hostname === new URL(this.redirURL).hostname) {
        this.reloadUrl(this.redirURL);
        return;
      }
      this.$window.location.href = this.redirURL;
    }
    catch(e) {
      this.redirURL = null;
      this.redirectScreenHtml = '';
      this.fs.error('Invalid redirect URL!');
      console.error(`Invalid redirect URL: ${e}`);
    }
  }

  loaded() {
    // TODO: This is a temporary solution. Needs a more deterministic approach.
    if (this.loadedCalled) return;
    this.loadedCalled = true;
    let ms = 500;
    this.$window.scrollTo({ top: 0 });
    this.$timeout(async() => {
      await this.beforeLoaded();
      await this.fe.loadMissingFonts(this.isDynamic, true);
      (typeof this.$window.pageIsReady === 'function') ?
        this.$window.pageIsReady("Form Loaded") :
        this.$window.pageIsReady = true;
      this.fs.success("Form Loaded");
      this.afterLoaded();
    }, ms);
  }

  async beforeLoaded() {}

  invokeControlsRendered() {
    this.ds.invokeControlsRendered(this.$document);
  }
  
  afterLoaded() {
    this.busyMessage = this.redirURL ? 'Redirecting...' : this.printing && this.hideFormForDownloadOnOpen ? 'Downloading document' : '';
    this.es.dispatchEvent(this.es.actions.RENDER_COMPLETE);
    this.es.disposeSubscribers("template", ["RENDER_COMPLETE"]);
    this.$timeout(_ => {
      this.renderCustomActionButtons(); 
      this.loadFieldSections();
      this.formLoaded = true;
      this.handleNavBar();
      this.handleAfterLoadMessages();
      this.updateFormValidity();
      this.invokeControlsRendered();
      if (this.printing && this.downloadOnOpen && !this.redirURL && !this.isBackendCall) {
        this.$timeout(() => void this.triggerAutoPdfDownloadIfRequested(), 150);
      }
    });
  }

  // Auto-trigger PDF download once render completes when link or URL requests downloadOnOpen.
  async triggerAutoPdfDownloadIfRequested() {
    if (this.isBackendCall) return;
    if (this.td?.template?.signTemplate === true) {
      this.applyDownloadOnOpenFromLink();
    }
    if (!this.downloadOnOpen || !this.printing || this.autoPdfDownloadDone) return;
    this.autoPdfDownloadDone = true;
    await this.saveFile(this.getDefaultDownloadFileName());
  }

  writeOnlySubmit() {
    this.successMessage('Thank you for submitting your form! You may now close this window.', undefined, 'thank-you-close-window');
    this.hideActions = true;
    this.$customActionButtons?.hide();
  }
  
  notifySuccessPrint() {
    if (!(this.successType && this.printing)) return;
    if (this.downloadOnOpen) return;
    this.successMessage('Click the "Download" button to generate and save a PDF copy to your hard drive.', undefined, 'click-download');
  }

  openLoginModal(realm, userRealm, validationErrorMessage) {

    const { prefix, domain } = this.PROVIDER;
    return new Promise((resolve, reject) => {
      const loginModal = this.ds.openModal(this.$uibModal, {
        template: `<${prefix}-login options="$ctrl.loginOptions"></${prefix}-login>`,
        scope: this.$scope,
        backdrop: 'static',
        keyboard: false,
        size: 'md'
      });

      this.loginOptions = {
        realm,
        title: `Login to ${realm}.${domain}`,
        userRealm,
        validationErrorMessage,
        onSuccess: (user) => {
          loginModal.dismiss("Canceled");
        }
      };

      loginModal.result.then(
        closed => { resolve() },
        canceled => { resolve() }
      );

    });
  }

  scrollToFirstInvalidField() {
    const form = this.previewForm;
    if (!form?.$error) return;
  
    // Lazy-init token label cache
    if (!this._tokenLabels && this.td?.template?.tokens) {
      this._tokenLabels = {};
      this.td.template.tokens.forEach(t => {
        this._tokenLabels[`${t.id}`] = t.options?.label || t.fieldSchema?.label || null;
      });
    }
  
    const seenControls = new Set();
    let topmost = null;
  
    Object.values(form.$error).forEach(invalidControls => {
      invalidControls?.forEach(control => {
        if (!control || seenControls.has(control)) return;
        seenControls.add(control);
  
        const element = control.$$element?.[0];
        if (!element) return;
  
        const feControlEl = element.closest?.('fe-control') || element;
        if (!feControlEl) return;
  
        const rect = feControlEl.getBoundingClientRect();
        const top = rect.top + this.$window.pageYOffset;
  
        // Find token id from class list
        let tokenId = null;
        const classList = feControlEl.classList || [];
        for (let i = 0; i < classList.length; i++) {
          const cls = classList[i];
          if (cls && cls.startsWith('token-id-')) {
            tokenId = cls.slice('token-id-'.length);
            break;
          }
        }
  
        const fieldLabel = tokenId && this._tokenLabels?.[tokenId] || null;
        const errorTypes = control.$error ? Object.keys(control.$error) : [];
  
        if (!topmost || top < topmost.top) {
          topmost = { element: feControlEl, top, errorTypes, control, fieldLabel };
        }
      });
    });
  
    if (!topmost) return;
  
    this.ds.scrollToElementAndFocus(topmost.element, { blink: true });
  
    return {
      element: topmost.element,
      errorTypes: topmost.errorTypes,
      control: topmost.control,
      fieldLabel: topmost.fieldLabel
    };
  }

  getInvalidFieldErrorMessage(errorTypes, fieldLabel) {
    const errorMessages = {
      'required': 'required', 'email': 'invalid email format', 'pattern': 'invalid format',
      'min': 'value too small', 'max': 'value too large', 'minlength': 'too short', 'maxlength': 'too long',
      'number': 'invalid number', 'date': 'invalid date', 'url': 'invalid URL'
    };
    
    const messages = (errorTypes && errorTypes.length > 0)
      ? errorTypes.map(type => errorMessages[type] || type).join(', ')
      : 'invalid';
    const errorText = messages;
    
    return fieldLabel ? `${fieldLabel}: ${errorText}` : errorText;
  }

  async attemptAction(saveAndKeepWorking=false) {
    this.setActionButtonsDisabled(true);
    this.$scope.$evalAsync(); // ensure buttons update
    this.hasInvalidFields = this.previewForm?.$invalid; // use current form state
    if (this.hasInvalidFields) {
      this.setActionButtonsDisabled(false);
      const errorInfo = this.scrollToFirstInvalidField();
      const errorMessage = errorInfo 
        ? this.getInvalidFieldErrorMessage(errorInfo.errorTypes, errorInfo.fieldLabel) 
        : "invalid fields";
      this.fs.error(errorMessage);
      return;
    }

    try {
      await this.onBeforeAction();
      // Give time to onBeforeAction triggered events to complete (ie: geolocation update on record service)
      this.$timeout(async _ => await this.runAction(saveAndKeepWorking), 400);
    } catch (err) {
      this.setActionButtonsDisabled(false);
      this.handleError(err);
    }
  }

  async runAction(saveAndKeepWorking=false) {
    switch (this.action) {
      case "update":
        return await this.sendForm('Updating Form...', saveAndKeepWorking);
      case "print":
        return await this.printForm();
      case "submit":
        return await this.sendForm('Submitting Form...', saveAndKeepWorking);
      default:
        return console.error("No Valid Action");
    }
  }

  // Post-submit navigation — signed links keep tokens/serverSignedAccess instead of rids.
  nextAction(newRids, nextAction, successType, saveAndKeepWorking=false, serverSignedAccessFromUpsert, afterSignedUpsert=false) {
    const isSignedTemplate = this.td?.template?.signTemplate === true;
    const newParams = {
      "templateId": this.ts.templateId,
      "previousAction": this.action,
      "successType": successType,
      ...(this.redirect ? { redirect: this.redirect } : {}),
      ...(saveAndKeepWorking ? { keepWorking: true } : {})
    };

    if (!isSignedTemplate) {
      newParams.action = nextAction;
      newParams.rids = newRids ? this.qps.encodeValue(newRids) : undefined;
    }
    
    if(this.suppliedConnection) {
      newParams.connection = JSON.stringify(this.suppliedConnection);
    }

    const serverToken =
      serverSignedAccessFromUpsert?.length > 0
        ? serverSignedAccessFromUpsert
        : this.qps.getRawParam('serverSignedAccess');

    if (isSignedTemplate && saveAndKeepWorking) {
      const signedRaw = this.qps.getRawParam('providerSignedAccess');
      const submitLinkRaw = this.qps.getRawParam('submitLinkId');
      if (signedRaw?.length) newParams.providerSignedAccess = signedRaw;
      if (submitLinkRaw?.length) newParams.submitLinkId = submitLinkRaw;
    } else if (serverToken?.length) {
      newParams.serverSignedAccess = serverToken;
      if (!isSignedTemplate) {
        delete newParams.rids;
        delete newParams.providerSignedAccess;
        delete newParams.submitLinkId;
      } else {
        delete newParams.action;
        delete newParams.rids;
        delete newParams.providerSignedAccess;
        delete newParams.submitLinkId;
      }
    } else {
      const signedRaw = this.qps.getRawParam('providerSignedAccess');
      const submitLinkRaw = this.qps.getRawParam('submitLinkId');
      if (signedRaw?.length) {
        newParams.providerSignedAccess = signedRaw;
        delete newParams.rids;
      }
      if (submitLinkRaw?.length) {
        newParams.submitLinkId = submitLinkRaw;
        delete newParams.rids;
      }
      if (!isSignedTemplate) {
        newParams.action = nextAction;
        if (!signedRaw?.length && !submitLinkRaw?.length) {
          newParams.rids = newRids ? this.qps.encodeValue(newRids) : undefined;
        }
      }
    }

    const route = this.isDynamic ? "render-dynamic" : "render-template";
    this.$state.go(route, newParams, {inherit: false, reload: true});
  }

  async onBeforeAction() {
    await this.initGeoData(true); // Reload geolocation data

    this.td.template.tokens.forEach(t => {
      if (t._temp) return;
      const feCtrl = this.$document.querySelector(`fe-control.token-id-${t.id}`);
      const ngCtrl = feCtrl?.firstElementChild ? angular.element(feCtrl.firstElementChild) : null;
      ngCtrl?.isolateScope().$ctrl?.onBeforeAction();
    });
  }

  missingFieldAlert() {
    const message = "Missing required data! Please fill out at least one field, including all required (red) fields.";
    this.handleError(new Error(message));
    this.setActionButtonsDisabled(false);
  }
  
  // Replace URL with serverSignedAccess after save-and-keep-working (drop PSA/submit tokens).
  syncSignedWorkingUrl(serverSignedAccess) {
    const route = this.isDynamic ? 'render-dynamic' : 'render-template';
    this.$state.go(route, {
      ...this.$state.params,
      templateId: this.ts.templateId,
      serverSignedAccess,
      submitLinkId: null,
      providerSignedAccess: null,
      keepWorking: true,
    }, { inherit: false, notify: false, reload: false, location: 'replace' });
  }

  async sendForm(busyMessage, saveAndKeepWorking=false) {
    if (this.reqBlank()) return this.missingFieldAlert();
    
    this.busyMessage = busyMessage;
    // Show the configured redirect message as soon as they submit (it may say "if needed...").
    // The label only becomes "Redirecting..." once we know the URL. Save & keep working never redirects.
    const willMaybeRedirect = !saveAndKeepWorking && !!this.getRedirectRef();
    const redirectUrlKnown = willMaybeRedirect && this.hasKnownRedirectUrl();
    if (willMaybeRedirect) this.redirectScreenHtml = this.getRedirectScreenHtml();

    try {
      // Clearing error messages before performing action to avoid confusing users (ex: multiple data rules fail and errors pile up even though some may have been fixed)
      this.userMessages = [];
      const { "data": { "rids": newRids, serverSignedAccess } } = await this.rcs.upsertRecords(
        undefined,
        undefined,
        { keepWorking: saveAndKeepWorking }
      );

      const isSignedKeepWorking =
        saveAndKeepWorking && this.td?.template?.signTemplate === true;

      if (isSignedKeepWorking) {
        this.rcs.applySaveAndKeepWorkingState(newRids);
        if (serverSignedAccess?.length) {
          this.rcs.applyEditableSignedWorkingSession(serverSignedAccess);
          this.syncSignedWorkingUrl(serverSignedAccess);
        }
        // Skip genForm when save-and-keep-working (PDF artifact refresh).
        this.fs.success('Saved');
        this.setActionButtonsDisabled(false);
      } else {
        this.genForm(newRids, this.action, serverSignedAccess, true, saveAndKeepWorking);

        if (this.getRedirectRef()) {
          // New records usually get their URL on save, so keep the submit label unless it's known.
          if (redirectUrlKnown) {
            this.busyMessage = 'Redirecting...';
            this.$scope.$evalAsync();
          }
          await this.$timeout(10000); // Make sure callGen is called before redirecting
        }

        const nextAction = saveAndKeepWorking ? "update" : "print";
        this.nextAction(newRids, nextAction, this.action, saveAndKeepWorking, serverSignedAccess, true);
      }
    } catch (error) {
      this.handleError(error);
      this.setActionButtonsDisabled(false);
    }
    this.busyMessage = '';
    this.redirectScreenHtml = '';
  }

  sanitizeDownloadBasename(raw) {
    if (raw == null) return '';
    let s = String(raw).replace(/[\x00-\x1f]/g, '').trim();
    s = s.replace(/[<>:"/\\|?*]/g, '_');
    s = s.replace(/[.\u00A0\s]+$/g, '');
    if (/^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])$/i.test(s)) s = `_${s}`;
    if (s.length > 200) s = s.slice(0, 200).replace(/[.\u00A0\s]+$/g, '');
    return s;
  }

  // Default PDF name — link upload filename field first, then ref fields or template title.
  getDefaultDownloadFileName() {
    const linkUpload = this.rcs.associatedLink?.upload;
    if (linkUpload?.filenameFieldId && linkUpload.referenceId) {
      const rec = this.rcs.records[linkUpload.referenceId];
      if (rec) {
        const cell = rec[linkUpload.filenameFieldId];
        if (cell) {
          const disp = cell.display != null && cell.display !== '' ? String(cell.display).trim() : '';
          const val = cell.value != null && cell.value !== '' ? String(cell.value).trim() : '';
          const safe = this.sanitizeDownloadBasename(disp || val);
          if (safe) return safe;
        }
      }
    }
    if (this.td.template.signTemplate) {
      return this.sanitizeDownloadBasename(this.td.template.title) || 'Form Engine PDF';
    }
    const refs = this.ts.references || [];
    for (const ref of refs) {
      if (ref._temp || !ref.filenameFID) continue;
      const rec = this.rcs.records[ref.id];
      if (!rec) continue;
      const cell = rec[ref.filenameFID];
      if (!cell) continue;
      const disp = cell.display != null && cell.display !== '' ? String(cell.display).trim() : '';
      const val = cell.value != null && cell.value !== '' ? String(cell.value).trim() : '';
      const safe = this.sanitizeDownloadBasename(disp || val);
      if (safe) return safe;
    }
    return this.sanitizeDownloadBasename(this.td.template.title) || 'Form Engine PDF';
  }

  async printForm() {
    this.defaultDownloadFileName = this.getDefaultDownloadFileName();
    this.downloadFileName = this.defaultDownloadFileName;
    this.modal = this.ds.openModal(this.$uibModal, {
      scope: this.$scope,
      template: `
        <div>
          <div class="modal-header"><h3 class="modal-title">Download File</h3></div>
          <div class="modal-body">
            <div class="input-group">
              <span class="input-group-addon" id="basic-addon1">File name</span>
              <input type="text" class="form-control" ng-model="$ctrl.downloadFileName"/>
            </div>
          </div>
          <hr />
          <div class="btn-group btn-group-justified" role="group">
            <div class="btn-group" role="group">
              <button class="btn btn-primary" ng-click="$ctrl.saveFile($ctrl.downloadFileName)" ng-disabled="!$ctrl.downloadFileName">Download</button>
            </div>
          </div>
        </div>`,
      keyboard: false,
      size: 'md'
    });
    this.modal.result.finally(() => this.setActionButtonsDisabled(false));
  }

  // Whether callGen should upload PDF to QB on print (link config or ref uploadFID).
  resolveGenerateOnPrint() {
    if (this.td?.template?.signTemplate === true) {
      return this.rcs.associatedLink?.upload?.genActions?.print === true;
    }
    return (this.ts.references || []).some(
      (r) => r.uploadFID && r.genActions?.print === true
    );
  }

  async saveFile(fileName) {
    this.userMessages = [];
    this.modal?.close();
    this.busyMessage = this.hideFormForDownloadOnOpen ? 'Downloading document' : 'Generating Pdf...';
    
    try {
      const { action } = this;
      const { "data": { pdf } } = await this.genForm(
        this.rcs.rids,
        action,
        undefined,
        false,
        false,
        this.resolveGenerateOnPrint()
      );
      const safeBase = this.sanitizeDownloadBasename(fileName) || 'Form Engine PDF';
      this.downloadFile(pdf, safeBase + '.pdf');
      if (this.downloadOnOpen) this.downloadCompleted = true;
      else this.fs.success("PDF Generated");
    }
    catch (error) {
      this.handleError(error);
      this.setActionButtonsDisabled(false);
    }
  
    this.$timeout(() => { this.busyMessage = '' });
  }

  // callGen request — attach signed access tokens and omit rids when link session is active.
  genForm(rids, action, serverSignedAccessFromUpsert, afterSignedUpsert=false, saveAndKeepWorking=false, generateOnPrint) {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const signedRaw = this.qps.getRawParam('providerSignedAccess');
    const submitLinkRaw = this.qps.getRawParam('submitLinkId');
    const serverToken =
      serverSignedAccessFromUpsert?.length > 0
        ? serverSignedAccessFromUpsert
        : this.qps.getRawParam('serverSignedAccess');
    const omitRids =
      this.td.template.signTemplate === true &&
      (serverToken?.length > 0 || signedRaw?.length > 0 || submitLinkRaw?.length > 0);
    const request = {
      rids: omitRids ? {} : rids,
      action,
      timeZone,
      templateId: this.ts.templateId,
    };
    if (generateOnPrint !== undefined) {
      request.generateOnPrint = generateOnPrint;
      const linkUpload = this.rcs.associatedLink?.upload;
      if (linkUpload) request.upload = linkUpload;
    }
    if (this.suppliedConnection) request.connection = this.suppliedConnection;
    if (this.td.template.signTemplate === true) {
      if (serverToken?.length) {
        request.serverSignedAccess = serverToken;
      } else {
        if (signedRaw?.length) request.providerSignedAccess = signedRaw;
        if (submitLinkRaw?.length) request.submitLinkId = submitLinkRaw;
        const passkeys = this.rcs.passkeys;
        if (passkeys && Object.keys(passkeys).length > 0) {
          request.passkeys = passkeys;
        }
      }
    }
    return this.fe.httpsCallable('callGen', request);
  }

  downloadFile(b64Pdf, fileName) {  
    const blob = this.rs.b64toBlob(b64Pdf, 'application/pdf', 512);
    const url = URL.createObjectURL(blob);
    const a = this.$document.createElement("a");
    this.$document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.hidden = true;
    a.download = fileName;
    a.click(); //TODO: don't trust the DOM!
    this.$window.URL.revokeObjectURL(url);
    a.remove();
    this.setActionButtonsDisabled(false);
  }

  // Close tab from download-on-open completion screen.
  closeBrowserWindow() {
    this.$window.close();
  }

  reset() {
    // ng-if flag that will reconstruct controls
    this.controlModelsReady = false;
    this.$timeout(() => {
      this.rcs.resetRecords();
      this.controlsLoaded = 0;
      this.controlModelsReady = true;
    });
  }

  reqComplete() {
    const records = this.rcs.records;
    // TODO: test carefully
    return (this.rcs.recordReferences || []).filter(r => !r._temp).every(ref => {
      if (!this.rcs.shouldEnforceRequiredFields(ref.id)) return true;
      const { fields } = this.schemas[ref.tableId];
      return fields.filter(f => f.required ).every( f => {
        return records?.[ref.id]?.[f.id];
      });
    });
  }

  reqBlank() {
    return !this.reqComplete() || !Object.keys(this.rcs.updatedRecords).length;
  }

  updateFormValidity() {
    const invalidForm =
      !this.paramsValid || this.missingRequiredFields
      || (!this.ts.references.length && !this.printing)
      || this.hasCriticalError 
      || (!this.rcs.hasUpdates && !this.printing);
    this.setActionButtonsDisabled(invalidForm);
    this.hasInvalidFields = this.previewForm?.$invalid;
  }

  showDebugInfo() {
    console.info("DEBUG INFO");
    console.info(this.ts);
    console.info(this.rcs);
    if (this.previewForm?.$invalid) {
      console.group("Invalid Form Data");
      const form = this.previewForm;
      Object.keys(form.$error).forEach(errorType => {
        console.group(`Error Type: ${errorType}`);
        form.$error[errorType].forEach(control => {
          const el = control.$$element;
          const feControlEl = el?.closest?.('fe-control');
          let fieldLabel = null, fieldId = null, label = null;
          if (feControlEl) {
            const feScope = angular.element(feControlEl).scope();
            fieldId = feScope?.token?.fieldId;
            fieldLabel = feScope?.token?.fieldSchema?.label;
            label = feScope?.token?.options?.label;
          }
          console.log({ fieldId, fieldLabel, label, modelValue: control.$modelValue, error: control.$error });
        });
        console.groupEnd();
      });
      console.groupEnd();
    }
  }

  // Debug modal — show per-target link metadata and policies on signed links.
  showRecInfo() {
    console.table(this.ts.references.map(r => { return { name: r.name, id: r.id, tableId: r.tableId }}));

    const idField = this.PROVIDER.recordIdField;
    if (this.busyMessage || !idField) return;

    this.modal?.close();

    const associatedLink = this.rcs.associatedLink;
    const recordIdFid = idField || '3';
    const resolveRecInfoIds = (record, ref, refId) => {
      const keyFid = ref?.tableSchema?.keyFieldId || recordIdFid;
      const displayRid = record?.[keyFid]?.value ?? this.rcs.rids[refId];
      const linkRid =
        record?.[recordIdFid]?.value ??
        (keyFid === recordIdFid ? displayRid : null);
      return {
        displayRid,
        linkRid,
        found: record?.[keyFid]?.value != null && record?.[keyFid]?.value !== '',
      };
    };
    const refsById = (this.ts.references || []).reduce((acc, ref) => {
      if (!ref._temp) acc[ref.id] = ref;
      return acc;
    }, {});

    // Classic submit URLs have no rids yet; signed links use per-ref targets instead.
    if (this.submitting && this.td?.template?.signTemplate !== true) this.recInfo = [];

    if (associatedLink?.targets?.length) {
      this.recInfo = associatedLink.targets.map((target) => {
        const refId = target.referenceId;
        const ref = refsById[refId];
        const record = this.rcs.records[refId];
        const { displayRid, linkRid, found } = resolveRecInfoIds(record, ref, refId);
        const hasRid = displayRid != null && displayRid !== '';
        const href = linkRid != null && linkRid !== '' && ref
          ? this.PROVIDER.recordLinkTemplate
            .replace('[REALM]', this.ts.template.realm)
            .replace('[TABLE_ID]', ref.tableId)
            .replace('[RID]', linkRid)
          : null;
        const actionLabel = target.action
          ? String(target.action).charAt(0).toUpperCase() + String(target.action).slice(1)
          : '';
        return {
          id: refId,
          name: ref?.name || refId,
          rid: hasRid ? displayRid : '—',
          href,
          found,
          linkAction: actionLabel,
          recordNotFound:
            target.action === 'update' || target.action === 'print'
              ? (target.recordNotFoundAction === 'ignore'
                ? 'Ignore'
                : target.recordNotFoundAction === 'warn'
                  ? 'Warn'
                  : target.recordNotFoundAction === 'create'
                    ? 'Create'
                    : 'Error')
              : '—',
          onEmptyRecord:
            target.action === 'submit'
            || ((target.action === 'update' || target.action === 'print')
              && target.recordNotFoundAction === 'create')
              ? (target.onEmptyRecordAction === 'ignore' ? 'Ignore' : 'Create')
              : '—',
        };
      }).sort((a, b) => a.name.localeCompare(b.name));
      this.recInfoLinkMeta = {
        linkId: associatedLink.linkId,
        label: associatedLink.label || associatedLink.hostField?.label || '',
        hostTable: associatedLink.hostTable?.name || associatedLink.hostTable?.id || '',
        hostField: associatedLink.hostField?.id || '',
      };
    } else {
      this.recInfoLinkMeta = null;
      const refs = (this.rcs.recordReferences || this.ts.references || []).filter((r) => !r._temp);
      this.recInfo = this.recInfo || refs.reduce((acc, ref) => {
        const refId = ref.id;
        const record = this.rcs.records[refId];
        if (!record) return acc;
        const { displayRid, linkRid, found } = resolveRecInfoIds(record, ref, refId);
        if (displayRid == null || displayRid === '') return acc;
        const href = linkRid != null && linkRid !== ''
          ? this.PROVIDER.recordLinkTemplate
            .replace('[REALM]', this.ts.template.realm)
            .replace('[TABLE_ID]', ref.tableId)
            .replace('[RID]', linkRid)
          : null;
        acc.push({ id: refId, name: ref.name, rid: displayRid, href, found });
        return acc;
      }, []).sort((a, b) => a.name.localeCompare(b.name));
    }

    this.recInfoTemplateId = this.ts?.templateId || this.td?.template?.id || '';

    const colSpan = this.recInfoLinkMeta ? 5 : 2;
    const templateIdBlock = this.recInfoTemplateId
      ? `<div class="row" style="margin-bottom: 10px;">
          <div class="col-xs-3"><span class="rec-info-label">Template ID:</span></div>
          <div class="col-xs-9"><span class="rec-info-value" ng-bind="$ctrl.recInfoTemplateId"></span></div>
        </div>`
      : '';
    const linkMetaBlock = this.recInfoLinkMeta
      ? `<div class="panel panel-default signed-link-rec-info-meta">
          <div class="panel-body">
            <div class="row" ng-if="$ctrl.recInfoLinkMeta.label">
              <div class="col-xs-3"><span class="rec-info-label">Description:</span></div>
              <div class="col-xs-9"><span class="rec-info-value" ng-bind="$ctrl.recInfoLinkMeta.label"></span></div>
            </div>
            <div class="row">
              <div class="col-xs-3"><span class="rec-info-label">Link ID:</span></div>
              <div class="col-xs-9"><span class="rec-info-value" ng-bind="$ctrl.recInfoLinkMeta.linkId"></span></div>
            </div>
            <div class="row" ng-if="$ctrl.recInfoLinkMeta.hostTable">
              <div class="col-xs-3"><span class="rec-info-label">Host table:</span></div>
              <div class="col-xs-9"><span class="rec-info-value" ng-bind="$ctrl.recInfoLinkMeta.hostTable"></span></div>
            </div>
            <div class="row" ng-if="$ctrl.recInfoLinkMeta.hostField">
              <div class="col-xs-3"><span class="rec-info-label">Host field:</span></div>
              <div class="col-xs-9"><span class="rec-info-value" ng-bind="$ctrl.recInfoLinkMeta.hostField"></span></div>
            </div>
          </div>
        </div>`
      : '';
    const tableHead = this.recInfoLinkMeta
      ? `<thead ng-if="$ctrl.recInfo.length"><tr>
          <th scope="col">Name</th><th scope="col">Record ID</th><th scope="col">Link action</th><th scope="col">Record not found</th><th scope="col">On empty record</th>
        </tr></thead>`
      : `<thead ng-if="$ctrl.recInfo.length"><tr><th scope="col">Name</th><th scope="col">ID</th></tr></thead>`;
    const tableRows = this.recInfoLinkMeta
      ? `<tr ng-repeat="rec in $ctrl.recInfo">
          <td ng-bind="rec.name"></td>
          <td>
            <a ng-if="rec.href" ng-href="{{rec.href}}" target="_blank">{{rec.rid}}</a>
            <span ng-if="!rec.href" ng-bind="rec.rid"></span>
            <i class="fa fa-exclamation text-danger" ng-if="!rec.found && rec.href"></i>
          </td>
          <td ng-bind="rec.linkAction"></td>
          <td ng-bind="rec.recordNotFound"></td>
          <td ng-bind="rec.onEmptyRecord"></td>
        </tr>`
      : `<tr ng-repeat="rec in $ctrl.recInfo">
          <td ng-bind="rec.name"></td>
          <td>
            <a ng-if="rec.href" ng-href="{{rec.href}}" target="_blank">{{rec.rid}}</a>
            <span ng-if="!rec.href" ng-bind="rec.rid"></span>
            <i class="fa fa-exclamation text-danger" ng-if="!rec.found"></i>
          </td>
        </tr>`;

    const recInfoTemplate =
      `<div>
        <div class="modal-header"><h4 class="modal-title">Form/record information</h4></div>
        <div class="modal-body">
          ${templateIdBlock}
          ${linkMetaBlock}
          <table class="table">
            ${tableHead}
            <tbody>
              ${tableRows}
              <tr>
                <td colspan="${colSpan}" style="text-align:center; border: none;">
                  <a href='{{$ctrl.builderUrl}}' target='_blank' class='btn btn-primary'>Builder page</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>`;

    this.modal = this.ds.openModal(this.$uibModal, {
      template: recInfoTemplate,
      scope: this.$scope,
      size: "md"
    });
    this.modal.result.then(
      closed => this.modal.close(),
      canceled => this.modal.close()
    );
  }
}